import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/api.service';
import { ResponseWorkflowService } from './response-workflow.service';
import { Model_ResponseWorkflow, StartupInfos_HistoriqueResponseWorkflows, QueryParams_ResponseWorkflow, PaginatedResults, CODE_WORKFLOW_COMPONENT } from 'src/app/app.models';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { UnitOfWorkOfflineDao } from '../../daos/unitofwork-offline.dao';

@Injectable()
export class ResponseWorkflowOnlineService extends ResponseWorkflowService {
    constructor(
        protected _unitOfWork: UnitOfWorkOfflineDao,
        private _httpClient: HttpClient,
        private _apiService: ApiService,
    ) {
        super(_unitOfWork);
    }

    doGetHistoriqueStartupInfosAction() {
        return this._httpClient.get<StartupInfos_HistoriqueResponseWorkflows>(this._apiService.endPoints.doGetHistoriqueStartupInfosAction_ResponseWorkflow)
        .pipe(catchError(error => throwError(!!error.error ? error.error.Message : 'Une erreur est survenue lors de la requete au serveur'))).toPromise();
    }
    
    doGetResponsesWorkflowAction(_queryParams: QueryParams_ResponseWorkflow) {
        return this._httpClient.post<PaginatedResults<Model_ResponseWorkflow>>(this._apiService.endPoints.doGetResponsesWorkflowAction_ResponseWorkflow, _queryParams)
        .pipe(catchError(error => throwError(!!error.error ? error.error.Message : 'Une erreur est survenue lors de la requete au serveur'))).toPromise();
    }

    doSyncResponseWorkflowAction(_responseWorkflow: Model_ResponseWorkflow) {
        return this._httpClient.post<void>(this._apiService.endPoints.doSyncResponseWorkflowAction_SynchronisationPeripherique, _responseWorkflow)
        .pipe(catchError(error => throwError(!!error.error ? error.error.Message : 'Une erreur est survenue lors de la requete au serveur'))).toPromise();
    }

    doSaveResponseWorkflowAction(_responseWorkflow: Model_ResponseWorkflow) {
        return this._httpClient.post<Model_ResponseWorkflow>(this._apiService.endPoints.doSaveResponseWorkflow_ResponseWorkflow, _responseWorkflow)
        .pipe(catchError(error => throwError(!!error.error ? error.error.Message : 'Une erreur est survenue lors de la requete au serveur'))).toPromise();
    }

    doGetResponseWorkflowByIDAction(ID: number) {
        return this._httpClient.get<Model_ResponseWorkflow>(this._apiService.endPoints.doGetResponseWorkflowByID_ResponseWorkflow + '/' + ID)
        .pipe(catchError(error => throwError(!!error.error ? error.error.Message : 'Une erreur est survenue lors de la requete au serveur'))).toPromise();
    }

    doCancelResponseWorkflow(ID: number) {
        return this._httpClient.post<Model_ResponseWorkflow>(this._apiService.endPoints.doCancelResponseWorkflow_ResponseWorkflow + '/' + ID, {})
        .pipe(catchError(error => throwError(!!error.error ? error.error.Message : 'Une erreur est survenue lors de la requete au serveur'))).toPromise();
    }

    doReadResponseWorkflowFile(componentCode: CODE_WORKFLOW_COMPONENT, filename: string) {
        let httpParams = new HttpParams();
        httpParams = httpParams.set('componentCode', componentCode).set('filename', filename);
        return this._httpClient.get<string>(this._apiService.endPoints.doReadResponseWorkflowFile_ResponseWorkflow, { params: httpParams, responseType: 'text' as any }).toPromise();
    }

    doDownloadResponseWorkflowFile(componentCode: CODE_WORKFLOW_COMPONENT, filename: string) {
        return new Promise<void>((resolve, reject) => {
            let httpParams = new HttpParams();
            httpParams = httpParams.set('componentCode', componentCode).set('filename', filename);
            this._httpClient.get(this._apiService.endPoints.doDownloadResponseWorkflowFile_ResponseWorkflow, { params: httpParams, responseType: 'blob' })
            .subscribe((downloadedFile: Blob) => {
              const a = document.createElement('a');
              a.setAttribute('style', 'display:none;');
              document.body.appendChild(a);
              //a.download = "FORMAT_IMPORT_EXPORT.egc";
              a.href = URL.createObjectURL(downloadedFile);
              a.target = '_blank';
              a.click();
              document.body.removeChild(a);
              resolve();
            });
        });
    }
}